const wrapperElementsNodes = document.querySelectorAll('.js-downward-scroll-wrapper');
const $wrapperElements = Array.prototype.slice.call(wrapperElementsNodes, 0);

const makePositionDownwardOnScroll = ($wrapper) => {
  const $elements = {
    basis: $wrapper.querySelector('.js-downward-scroll-basis'),
    target: $wrapper.querySelector('.js-downward-scroll-target')
  };

  function toggleActiveClassOnTarget (flg) {
    $elements.target.classList[flg ? 'add' : 'remove']('downward');
  }

  function isScrollTopThanTarget () {
    const basisRect = $elements.basis.getBoundingClientRect();
    return basisRect.top < $elements.target.offsetHeight;
  }

  function eventHandler () {
    toggleActiveClassOnTarget(isScrollTopThanTarget());
  }

  function addEvent () {
    window.addEventListener('scroll', () => {
      eventHandler();
    });
  }

  function isElementsExists () {
    return !!($elements.basis !== null && $elements.target !== null);
  }

  function init () {
    if (isElementsExists()) {
      addEvent();
      eventHandler();
    }
  }

  init();
};

window.addEventListener('DOMContentLoaded', () => {
  if ($wrapperElements !== null) {
    $wrapperElements.forEach(el => {
      makePositionDownwardOnScroll(el);
    });
  }
});
